'use strict';

function headerFunction(g) {
  // on déclare ici les variables propres à cette fonction
  var $header = $('#header-main');
  var $subMenu = $('.nav-main__submenu');
  var scrollMagicIsSet = false;
  var controller;
  var scene;
  var $sousMenuVoile = $('.menu-item-voile .nav-main__submenu');

  function init() {
    var headerHeight = $header.find('.l-container--header').outerHeight();
    $('.main-content').css('paddingTop', headerHeight);

    if (window.matchMedia('(min-width: 1024px)').matches && (!scrollMagicIsSet) ) {
      scrollMagicIsSet = true;
      controller = new ScrollMagic.Controller({addIndicators: true});
      controller = new ScrollMagic.Controller();
      scene = new ScrollMagic.Scene({offset: headerHeight})
          .setPin('#header-main')
          .on('enter leave', function() {
            $header.toggleClass('is-collapse');
            $('body').toggleClass('is-menu-collapse');
            $('.nav-main__principal .btn').toggleClass('btn--small-height btn--medium-height');
            if ($sousMenuVoile.length) {
              updateMenuVoilePosition();
            }
          })
          .on('enter', function() {
            $header.addClass('is-transitionning');

            setTimeout(function() {
              $header.removeClass('is-transitionning');
            }, 400);
          })
          .on('leave', function() {
            $header.css('inset', 'auto');
          })
          .addTo(controller);
    } else {
      scrollMagicIsSet = false;
      $header.removeClass('is-collapse is-open');
      $('.nav-main__principal .btn').toggleClass('btn--small-height btn--medium-height');
    }

    $(window).on('load',function() {
      $('.js-toggle-menu-mobile, .menu-mobile-overlay').click(function() {
        $('body').toggleClass('is-menu-mobile-open');
      });
    });

    // Si on est en menu mobile, on empêche de suivre le lien si il y a un dropdown

    if (! window.matchMedia('(min-width: 1024px)').matches ) {
      $subMenu.hide();

      $('.dropdown-toggle').click(function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $(e.currentTarget).parents('.menu-item-has-children').toggleClass('submenu-is-open');
        $(e.currentTarget).parents('.menu-item-has-children').find('.nav-main__submenu').slideToggle({
          start: function() {
            $(this).css({
              display: 'block'
            });
          }
        });
      });
    } else {
      $subMenu.show();
    }
  }

  function updateMenuVoilePosition() {
    $sousMenuVoile.attr('style', '');

    if (window.matchMedia('(min-width: 1024px)').matches ) {
      var headerOffsetLeft = $('.header-main').offset().left;
      var headerWidth = $('.header-main').width();
      var menuOffsetLeft = $sousMenuVoile.offset().left;
      var leftPos = parseFloat(-1*menuOffsetLeft + headerOffsetLeft) + 'px';

      $sousMenuVoile.css({
        left: leftPos,
        width: headerWidth,
        display: 'flex',
        justifyContent: 'center'
      });
    } else {
      $sousMenuVoile.css({
        display: 'none'
      });
    }
  }

  init();

  if ($sousMenuVoile.length) {
    updateMenuVoilePosition();
  }

  $(window).resize(function() {
    if (scene !== undefined) {
      scene.destroy(true);
    }
    scrollMagicIsSet = false;
    init();

    if ($sousMenuVoile.length) {
      updateMenuVoilePosition();
    }
  });
}
